
/**
 * Map allowing converting HQ browser status to corresponding PrimeNG severity
 */
export const statusPrimeSeverityMap = {
    warning: 'warn',
    error: 'error',
};
